function n(t) {
  return typeof t == "string";
}
export {
  n as i
};
//# sourceMappingURL=isHostComponent-kiaBvYVo.mjs.map
